import { IconDeclaration } from './types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';

const LoadingImage = ({ props }) => <img alt="loading" {...props?.attributes} />;
const IconEmojiCheck = dynamicEditorComponent(
  () => import('@doltech/icons-from-dev/emoji/IconEmojiCheck').then((mod) => mod.IconEmojiCheck),
  { loading: LoadingImage }
);
const IconEmojiSmileys36 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys36').then(
      (mod) => mod.IconEmojiSmileys36
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys37 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys37').then(
      (mod) => mod.IconEmojiSmileys37
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys38 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys38').then(
      (mod) => mod.IconEmojiSmileys38
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys39 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys39').then(
      (mod) => mod.IconEmojiSmileys39
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys5 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys5').then((mod) => mod.IconEmojiSmileys5),
  { loading: LoadingImage }
);
const IconEmojiSmileys32 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys32').then(
      (mod) => mod.IconEmojiSmileys32
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys6 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys6').then((mod) => mod.IconEmojiSmileys6),
  { loading: LoadingImage }
);
const IconEmojiSmileys33 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys33').then(
      (mod) => mod.IconEmojiSmileys33
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys7 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys7').then((mod) => mod.IconEmojiSmileys7),
  { loading: LoadingImage }
);
const IconEmojiSmileys34 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys34').then(
      (mod) => mod.IconEmojiSmileys34
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys35 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys35').then(
      (mod) => mod.IconEmojiSmileys35
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys8 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys8').then((mod) => mod.IconEmojiSmileys8),
  { loading: LoadingImage }
);
const IconEmojiSmileys9 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys9').then((mod) => mod.IconEmojiSmileys9),
  { loading: LoadingImage }
);
const IconEmojiSmileys30 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys30').then(
      (mod) => mod.IconEmojiSmileys30
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys31 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys31').then(
      (mod) => mod.IconEmojiSmileys31
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys1 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys1').then((mod) => mod.IconEmojiSmileys1),
  { loading: LoadingImage }
);
const IconEmojiSmileys2 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys2').then((mod) => mod.IconEmojiSmileys2),
  { loading: LoadingImage }
);
const IconEmojiSmileys3 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys3').then((mod) => mod.IconEmojiSmileys3),
  { loading: LoadingImage }
);
const IconEmojiSmileys4 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys4').then((mod) => mod.IconEmojiSmileys4),
  { loading: LoadingImage }
);
const IconEmojiSmileys47 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys47').then(
      (mod) => mod.IconEmojiSmileys47
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys48 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys48').then(
      (mod) => mod.IconEmojiSmileys48
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys43 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys43').then(
      (mod) => mod.IconEmojiSmileys43
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys44 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys44').then(
      (mod) => mod.IconEmojiSmileys44
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys45 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys45').then(
      (mod) => mod.IconEmojiSmileys45
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys46 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys46').then(
      (mod) => mod.IconEmojiSmileys46
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys40 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys40').then(
      (mod) => mod.IconEmojiSmileys40
    ),
  { loading: LoadingImage }
);
const IconEmojiCross = dynamicEditorComponent(
  () => import('@doltech/icons-from-dev/emoji/IconEmojiCross').then((mod) => mod.IconEmojiCross),
  { loading: LoadingImage }
);
const IconEmojiSmileys41 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys41').then(
      (mod) => mod.IconEmojiSmileys41
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys42 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys42').then(
      (mod) => mod.IconEmojiSmileys42
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys18 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys18').then(
      (mod) => mod.IconEmojiSmileys18
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys19 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys19').then(
      (mod) => mod.IconEmojiSmileys19
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys14 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys14').then(
      (mod) => mod.IconEmojiSmileys14
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys15 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys15').then(
      (mod) => mod.IconEmojiSmileys15
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys16 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys16').then(
      (mod) => mod.IconEmojiSmileys16
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys17 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys17').then(
      (mod) => mod.IconEmojiSmileys17
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys10 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys10').then(
      (mod) => mod.IconEmojiSmileys10
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys11 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys11').then(
      (mod) => mod.IconEmojiSmileys11
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys12 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys12').then(
      (mod) => mod.IconEmojiSmileys12
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys13 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys13').then(
      (mod) => mod.IconEmojiSmileys13
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys29 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys29').then(
      (mod) => mod.IconEmojiSmileys29
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys25 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys25').then(
      (mod) => mod.IconEmojiSmileys25
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys26 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys26').then(
      (mod) => mod.IconEmojiSmileys26
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys27 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys27').then(
      (mod) => mod.IconEmojiSmileys27
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys28 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys28').then(
      (mod) => mod.IconEmojiSmileys28
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys21 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys21').then(
      (mod) => mod.IconEmojiSmileys21
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys22 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys22').then(
      (mod) => mod.IconEmojiSmileys22
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys23 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys23').then(
      (mod) => mod.IconEmojiSmileys23
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys24 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys24').then(
      (mod) => mod.IconEmojiSmileys24
    ),
  { loading: LoadingImage }
);
const IconEmojiSmileys20 = dynamicEditorComponent(
  () =>
    import('@doltech/icons-from-dev/emoji/IconEmojiSmileys20').then(
      (mod) => mod.IconEmojiSmileys20
    ),
  { loading: LoadingImage }
);

export const ELEMENT_ICON = 'ICON';

export const DEFAULT_ICONS: IconDeclaration[] = [
  { key: 'check', component: IconEmojiCheck },
  { key: 'cross', component: IconEmojiCross },
  { key: 'smiley35', component: IconEmojiSmileys35 },
  { key: 'smiley14', component: IconEmojiSmileys14 },
  { key: 'smiley7', component: IconEmojiSmileys7 },
  { key: 'smiley28', component: IconEmojiSmileys28 },
  { key: 'smiley42', component: IconEmojiSmileys42 },

  //
  { key: 'smiley25', component: IconEmojiSmileys25 },
  { key: 'smiley5', component: IconEmojiSmileys5 },
  { key: 'smiley39', component: IconEmojiSmileys39 },
  { key: 'smiley18', component: IconEmojiSmileys18 },
  { key: 'smiley11', component: IconEmojiSmileys11 },
  { key: 'smiley32', component: IconEmojiSmileys32 },
  { key: 'smiley46', component: IconEmojiSmileys46 },

  //
  { key: 'smiley3', component: IconEmojiSmileys3 },
  { key: 'smiley23', component: IconEmojiSmileys23 },
  { key: 'smiley37', component: IconEmojiSmileys37 },
  { key: 'smiley16', component: IconEmojiSmileys16 },
  { key: 'smiley9', component: IconEmojiSmileys9 },
  { key: 'smiley30', component: IconEmojiSmileys30 },
  { key: 'smiley44', component: IconEmojiSmileys44 },

  //
  { key: 'smiley6', component: IconEmojiSmileys6 },
  { key: 'smiley27', component: IconEmojiSmileys27 },
  { key: 'smiley41', component: IconEmojiSmileys41 },
  { key: 'smiley20', component: IconEmojiSmileys20 },
  { key: 'smiley13', component: IconEmojiSmileys13 },
  { key: 'smiley34', component: IconEmojiSmileys34 },
  { key: 'smiley48', component: IconEmojiSmileys48 },

  //
  { key: 'smiley2', component: IconEmojiSmileys2 },
  { key: 'smiley22', component: IconEmojiSmileys22 },
  { key: 'smiley36', component: IconEmojiSmileys36 },
  { key: 'smiley15', component: IconEmojiSmileys15 },
  { key: 'smiley8', component: IconEmojiSmileys8 },
  { key: 'smiley29', component: IconEmojiSmileys29 },
  { key: 'smiley43', component: IconEmojiSmileys43 },
  //
  { key: 'smiley26', component: IconEmojiSmileys26 },
  { key: 'smiley40', component: IconEmojiSmileys40 },
  { key: 'smiley19', component: IconEmojiSmileys19 },
  { key: 'smiley12', component: IconEmojiSmileys12 },
  { key: 'smiley33', component: IconEmojiSmileys33 },
  { key: 'smiley47', component: IconEmojiSmileys47 },
  { key: 'smiley4', component: IconEmojiSmileys4 },
  //
  { key: 'smiley24', component: IconEmojiSmileys24 },
  { key: 'smiley38', component: IconEmojiSmileys38 },
  { key: 'smiley17', component: IconEmojiSmileys17 },
  { key: 'smiley10', component: IconEmojiSmileys10 },
  { key: 'smiley31', component: IconEmojiSmileys31 },
  { key: 'smiley45', component: IconEmojiSmileys45 },
  { key: 'smiley1', component: IconEmojiSmileys1 },
  //
  { key: 'smiley21', component: IconEmojiSmileys21 },
];

export const DEFAULT_ICON = {
  img: {
    component: null,
    type: ELEMENT_ICON,
    rootProps: {
      className: 'slate-icon',
    },
    icons: DEFAULT_ICONS,
    size: '1.6em',
  },
};
